import encodeQueryData from '../utils/Query';
import { API } from '../utils/amplifyWrapper';

export const fetchContentsService = ({org_id, id, filter}) => {
    const {nextPageToken, startDate, endDate, contentType} = filter

    let url = `/organisation/${org_id}/integration/${id}/content`;

    let params = { };

    if(nextPageToken){

        params["next_page_token"] = nextPageToken;

    }

    if(startDate){

        params["start_date"] = startDate;

    }

    if(endDate){

        params["end_date"] = endDate;

    }

    if(contentType){

        params['contentType'] = contentType

    }

    if(Object.keys(params).length > 0){

        url = url + "?" + encodeQueryData(params);

    }
    
    return API.get(`main`, url).then(res => {
        let data = {
            contents : res.data,
            filter
        }
        if(res.hasOwnProperty("next_page_token")){
            data["nextPageToken"] = res.next_page_token
        }
        return data
    }).catch(err => {
        return err
    })
}

export const fetchContentsSearchService = ({org_id, id, keyword}) => {
    return API.get(`main`, `/organisation/${org_id}/integration/${id}/search?keyword=${keyword}`,{headers: {"Content-Type":"application/json"}}).then((res)=>{
        let data = {
            contents : res.data,
        }
        return data
    }).catch(err => {
        return err
    })
}

export const generateSRTService = ({org_id, id, contentId, body}) => {
    return API.put('main', `/organisation/${org_id}/integration/${id}/content/${contentId}/generate-srt`, {
        body, headers: { "Content-Type": "application/json" }
    }).then(res => {
        return res
    }).catch(err => {
        return err
    })
}

export const pingSRTService = ({org_id, id, contentId}) => {
    return API.get('main', `/organisation/${org_id}/integration/${id}/content/${contentId}/get-srt`, {
        headers: { "Content-Type": "application/json" }
    }).then(res => {
        return res.data
        
    }).catch(err => {
        console.log(err)
        return err
        
    })
}

// Audio Upload Services
export const getAudioSignedUrlService = async ({ org_id, integration_id, file_name, content_type }) => {
    const response = await API.get('main', `/organisation/${org_id}/integration/${integration_id}/audio/signed-url`, {
        queryStringParameters: {
            file_name,
            content_type,
            file_name_prefix: "fa"
        }
    });
    return response.data;
};

export const uploadAudioToS3Service = async (signed_url, file) => {
    await fetch(signed_url, {
        method: 'PUT',
        body: file,
        redirect: 'follow'
    });
};

export const createUploadedAudioService = async ({ org_id, integration_id, title, url }) => {
    const response = await API.post('main', `/organisation/${org_id}/integration/${integration_id}/audio/upload`, {
        body: { title, url },
        headers: { "Content-Type": "application/json" }
    });
    return response.data;
};

export const updateUploadedAudioService = async ({ org_id, integration_id, content_id, title, url }) => {
    const response = await API.put('main', `/organisation/${org_id}/integration/${integration_id}/content/${content_id}/audio/upload`, {
        body: { title, url },
        headers: { "Content-Type": "application/json" }
    });
    return response.data;
};
